import React from 'react';

const lunchSpecial = React.forwardRef((props, ref) => {
  return (
    <section ref={ref} id="lunchSpecial" className=" p-8 text-center">

<h2 className="h2 text-4xl font-bold">Reservations</h2>
<p className="pretitle text-lg">In and Out of House</p>
<div className='grid grid-row'>
<span>Empower both your team and customers with more control over reservations than ever.</span>
<br/>
<span>Enabled from your GoHost App on any device supporting the Android / Google Play App Store, your table availablity will automatically be filtered by:</span>
<span>Regular Hours, Holidays, Custom Hours, and Exsiting Reservations for Each Table</span>
</div>
<br/> 
<span>The "Reservation Length" Setting in the GoHost App allows owners to determine how much time is allocated for each reservation.  </span>
<br/>
<br/>
<span>When a reservation is in place, the App blocks off the "Reservation Length" time for that table for the duration of the reservation but also prior to it- so that bookings don't ever have any overlap.</span>
<br/>

<br/> 

<span> Selecting the "Reservations" button in the dashbaord, you have a birds eye view of all reservations for the day.</span>
<br/>
<span>On this screen you can change the date to view all future reservations, check the customer's information for each, and add reservations or update existing ones </span>

    </section>

    );
});

export default lunchSpecial;